/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-key */
/* eslint-disable @next/next/no-img-element */
import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import SocialSharingLinks from "@modules/study/common/social_sharing_links";
import { VlogSectionHeading } from "@modules/study/common/vlog";
import { Grid, IconButton } from "@mui/material";
import { getAssets, htmlParse } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import moment from "moment";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { AiOutlineDislike, AiOutlineLike } from "react-icons/ai";
const ReactPlayer = dynamic(() => import("react-player"), {
  ssr: false,
});
import { useRecoilValue } from "recoil";
import VlogRecommended from "../../components/recommended";
import styles from "./vlog_playlist_details.module.scss";
const UniComment = dynamic(() => import("@modules/study/common/comment"), {
  ssr: false,
});
const baseUrl = process.env.NEXT_PUBLIC_URL;

export const VlogPlaylistDetail = ({ playListDetail }) => {
  console.log(playListDetail);
  const [id, setId] = useState(0);
  const profileInfo = useRecoilValue(authAtom);
  const systemActions = useSystemActions();
  const [video, setVideo] = useState({});
  const [like, setLike] = useState();
  const [disLike, setDisLike] = useState(false);
  const [countLike, setCountLike] = useState(false);
  const router = useRouter();
  const slug = router.asPath;
  const keyword = playListDetail.searchHead.slug;

  const getData = async () => {
    await API.get(
      `/public/vlog/user/like-dislike?vlogSlug=${video?.slug}`
    ).then((res) => {
      if (!res.error && res.data) {
        const { user } = res.data;
        setCountLike(res.data);
        if (user?.likeStatus === 1) {
          setLike(true);
          setDisLike(false);
        } else if (user?.dislikeStatus === 1) {
          setDisLike(true);
          setLike(false);
        } else if (user?.likeStatus === 0) {
          setLike(false);
        } else if (user?.dislikeStatus === 0) {
          setDisLike(false);
        } else if (user === null) {
          setDisLike(false);
          setLike(false);
        }
      }
    });
  };

  const getGuestData = async () => {
    await API.get(
      `/public/vlog/guest/like-dislike?vlogSlug=${video?.slug}`
    ).then((res) => {
      if (!res.error && res.data) {
        const { user } = res.data;
        setCountLike(res.data);
      }
    });
  };

  useEffect(() => {
    if (video?.slug && profileInfo) {
      getData();
    } else if (video?.slug) {
      getGuestData();
    }
  }, [video?.slug, profileInfo, like, disLike]);

  useEffect(() => {
    if (video && Object.keys(video)?.length === 0) {
      setVideo(playListDetail?.results[0]);
    }
  }, [video, playListDetail?.results]);

  const apiPost = async (like, disLike) => {
    await API.post("/public/vlog/like-dislike", {
      postId: video?.id,
      likeStatus: like ? 1 : 0,
      dislikeStatus: disLike ? 1 : 0,
    }).then(async (res) => {
      if (!res.error) {
        await getData();
      }
    });
  };

  const likeAction = async () => {
    if (disLike) {
      setDisLike(false);
      setLike(true);
      await apiPost(true, false);
    } else {
      setLike(!like);
      await apiPost(!like, disLike);
    }
  };

  const disLikeAction = async () => {
    if (like) {
      setLike(false);
      setDisLike(true);
      await apiPost(false, true);
    } else {
      setDisLike(!disLike);
      await apiPost(like, !disLike);
    }
  };

  let videoUrl;
  if (video?.videoType == "vimeo") {
    videoUrl = `https://vimeo.com/${video?.embeddedCode}`;
  } else {
    videoUrl = `https://youtu.be/${video?.embeddedCode}`;
  }

  return (
    <div>
      <VlogSectionHeading style={{ padding: "200px 0" }} />
      <section>
        <div className="container relative">
          <div className={`${styles.section_wrapper}`}>
            <Grid container spacing={0}>
              <Grid item lg={9} xl={9} md={8} sm={12} xs={12}>
                <div className={`${styles.detail_video_wrapper} relative`}>
                  <ReactPlayer
                    width="100%"
                    url={videoUrl}
                    playing={true}
                    className={styles.react_player}
                    playIcon={<PlayButtonWithRipple />}
                    light={video?.featuredImage?.src}
                    controls
                  />
                </div>
                <div className={styles.heading_wrapper}>
                  <div className={styles.left_wrapper}>
                    <div className={styles.title}>{video?.title}</div>
                    <div className={styles.sub_titile}>
                      {video?.totalView} Views ●{" "}
                      {moment(video?.publishedDate).format("MMMM DD, YYYY")}
                    </div>
                  </div>
                  <div className={styles.right_wrapper}>
                    <div className={styles.like_wrapper}>
                      <div className="relative">
                        <IconButton
                          onClick={() => {
                            if (profileInfo) {
                              likeAction();
                            } else {
                              systemActions.setReturnUrl(router.asPath);
                              return router.push({ pathname: "/signin" });
                            }
                          }}
                          className={
                            like
                              ? `${styles.like_icon} ${styles.active}`
                              : `${styles.like_icon}`
                          }
                        >
                          <AiOutlineLike />
                        </IconButton>
                        <span className={styles.display}>
                          {countLike?.likeCount}
                        </span>
                        {/* <div className={`uni-tooltip`}>
                          Please Login <br /> to perform this action
                        </div> */}
                      </div>

                      <div className={styles.border}>
                        <IconButton
                          onClick={() => {
                            if (profileInfo) {
                              disLikeAction();
                            } else {
                              systemActions.setReturnUrl(router.asPath);
                              return router.push({ pathname: "/signin" });
                            }
                          }}
                          className={`${styles.like_icon} ${
                            disLike ? `${styles.active}` : ""
                          }`}
                        >
                          <AiOutlineDislike />
                        </IconButton>
                        <span className={styles.display}>
                          {countLike?.dislikeCount}
                        </span>
                      </div>
                    </div>
                    <div className="relative">
                      <SocialSharingLinks
                        className="vlog_socile_wrapper"
                        url={`${baseUrl}/${slug}`}
                        title={video?.title}
                      />
                    </div>
                    {/* <div style={{ display: "flex", alignItems: "center" }}>
                      <IconButton className={styles.icon}>
                        <RiShareForwardFill />
                      </IconButton>
                      <span className={styles.display}>Share</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <IconButton className={styles.icon}>
                        <BsThreeDotsVertical />
                      </IconButton>
                    </div> */}
                  </div>
                </div>
              </Grid>
              <Grid item lg={3} xl={3} md={4} sm={12} xs={12}>
                <div className={styles.list_wrapper}>
                  <div className={styles.list_heading_wrapper}>
                    <div className={styles.list_title}>
                      {playListDetail?.searchHead?.title}
                    </div>
                    <div className={styles.list_sub_title}>
                      Total Videos - {id + 1}/{playListDetail?.total}
                    </div>
                  </div>
                  <div className={styles.list_video}>
                    <ul>
                      {playListDetail &&
                        playListDetail?.results?.length > 0 &&
                        playListDetail?.results?.map((item, i) => (
                          <li
                            onClick={async () => {
                              setId(--i);
                              setVideo(item);
                              await getData();
                            }}
                            key={i}
                            className={
                              id === i
                                ? `${styles.list} ${styles.active}`
                                : `${styles.list}`
                            }
                          >
                            <span className={styles.counter}>
                              {/*id === i ? <FaPlay /> : i++*/}
                              {++i}
                            </span>
                            <div
                              className={styles.image_wrapper}
                              title={item?.title}
                            >
                              <img
                                src={
                                  item?.featuredImage?.src ||
                                  item?.thumbnail?.src ||
                                  getAssets(
                                    "assets/images/video_placeholder_big.png"
                                  )
                                }
                                alt={item?.title}
                              />
                              <PlayButtonWithRipple small ripple={false} />
                            </div>
                            <div className={styles.details_wrapper}>
                              <div className={styles.title} title={item?.title}>
                                {item?.title}
                              </div>
                              <div className={styles.sub_title}>
                                {item?.totalView} Views ●{" "}
                                {moment(item?.publishedDate).format(
                                  "MMMM DD, YYYY"
                                )}
                              </div>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
                <div style={{ paddingLeft: "28px" }}>
                  <VlogRecommended keyword={keyword} />
                </div>
              </Grid>
            </Grid>
          </div>

          <Grid container spacing={4} sx={{ mt: 1 }}>
            <Grid item md={9} sm={12} xs={12}>
              {playListDetail &&
                playListDetail?.searchHead?.content &&
                htmlParse(playListDetail?.searchHead?.content)}

              <div className={styles.comment_wrapper}>
                <UniComment />
              </div>
            </Grid>
            <Grid item md={3} sm={12} xs={12}>
              {/*<div className={styles.recomended_video}>
                <h2>Recomended Videos</h2>
                <ul>
                  <li>
                    <div className={styles.image_wrapper}>
                      <img
                        src="https://images.ctfassets.net/hrltx12pl8hq/7yQR5uJhwEkRfjwMFJ7bUK/dc52a0913e8ff8b5c276177890eb0129/offset_comp_772626-opt.jpg?fit=fill&w=800&h=300"
                        alt="rashed"
                      />
                      <PlayButtonWithRipple small ripple={false} />
                    </div>
                    <div className={styles.details_wrapper}>
                      <Link  legacyBehavior   href="#">
                        <a className={styles.title}>
                          Learn How to Ace Your College Essay in 5 Minutes
                        </a>
                      </Link>
                      <div className={styles.sub_title}>
                        3.7k Views ● February 28, 2022
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className={styles.image_wrapper}>
                      <img
                        src="https://images.ctfassets.net/hrltx12pl8hq/7yQR5uJhwEkRfjwMFJ7bUK/dc52a0913e8ff8b5c276177890eb0129/offset_comp_772626-opt.jpg?fit=fill&w=800&h=300"
                        alt="rashed"
                      />
                      <PlayButtonWithRipple small ripple={false} />
                    </div>
                    <div className={styles.details_wrapper}>
                      <Link  legacyBehavior   href="#">
                        <a className={styles.title}>
                          Learn How to Ace Your College Essay in 5 Minutes
                        </a>
                      </Link>
                      <div className={styles.sub_title}>
                        3.7k Views ● February 28, 2022
                      </div>
                    </div>
                  </li>
                </ul>
              </div>*/}
            </Grid>
          </Grid>
        </div>
      </section>
    </div>
  );
};

export default VlogPlaylistDetail;
